export function rewriteUrlOrigin(
    url: string,
    sourceOrigin: string,
    replacementOrigin: string,
): string | null {
    if (!url.startsWith(sourceOrigin)) {
        return null;
    }

    const nextCharacter = url.charAt(sourceOrigin.length);
    if (
        nextCharacter.length > 0 &&
        nextCharacter !== '/' &&
        nextCharacter !== '?' &&
        nextCharacter !== '#'
    ) {
        return null;
    }

    return `${replacementOrigin}${url.slice(sourceOrigin.length)}`;
}
